import { createApp } from 'vue'
import WeatherWidget from "@/components/WeatherWidget"
import './assets/style/tailwind.css'

createApp(WeatherWidget).mount('weather-widget')
